export default {"src":"/_next/static/media/Atalanta.08bdb2b2.svg","height":251,"width":153,"blurWidth":0,"blurHeight":0};